import React, { FC } from 'react'

import { RTEContent } from '@Components/RTEContent'
import { Block } from '@Generated/graphql'
import { getRTEFieldValue } from '@Globals/CMS/FieldHelpers'

import styles from './QuoteBlock.module.scss'

interface QuoteBlockProps {
  id?: string
  quoteBlock: Block
}
const QuoteBlock: FC<QuoteBlockProps> = ({ id, quoteBlock }) => {
  const text = getRTEFieldValue(quoteBlock.fields || [], 'text')
  if (!text) {
    return null
  }

  return (
    <RTEContent className={styles.quote} data={text} elementType="blockquote" id={id} />
  )
}

export default QuoteBlock
